import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  
  // No isolated pages - show navigation on all pages
  const isIsolatedPage = false;
  
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <nav>
        {!isIsolatedPage && (
          <ul className="nav-links">
            <li>
              <NavLink
                to="/projects"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Some Experience
              </NavLink>
            </li>
          </ul>
        )}
      </nav>
    </header>
  );
}

export default Header;
